import { RootStackParamList } from '$tablet-app/src/app/components/PrimaryNavigator';
import useRecordThumbnail from '$tablet-app/src/app/images/hooks/useRecordThumbnail';
import { useGetMeal } from '@akin-home/meals/react';
import { Text } from '@akin-home/text/native';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { format } from 'date-fns';
import styled from 'styled-components/native';
import { ChatItemDialogBody, ChatItemHeader } from '../../ChatItem';
import { ChatCalendarItem } from '../../ChatItem/types';
import { useDismissChatItemDialog } from '../ChatItemDialog';
import { ChatItemDialogProps } from '../ChatItemDialog/ChatItemDialogProps';

export const MealChatDialog = (
  props: ChatItemDialogProps<ChatCalendarItem>
) => {
  const {
    chat_item: {
      data: { items },
    },
  } = props;

  const onDismiss = useDismissChatItemDialog();

  const { navigate } = useNavigation<NavigationProp<RootStackParamList>>();

  const { item } = useGetMeal({
    id: items[0]?.item_id,
  });

  const goToRecipe = () => {
    const recipe_id = item?.recipes[0]?.id;
    if (recipe_id) navigate('RecipeDetails', { recipe_id });

    onDismiss();
  };

  const { source } = useRecordThumbnail({ record: item });

  return item ? (
    <>
      <ChatItemHeader
        title="meals"
        icon="salad"
        onPressOpen={goToRecipe}
        onDismiss={onDismiss}
      />
      <ChatItemDialogBody>
        <BodyContainer onPress={goToRecipe}>
          {source ? <MealImage source={source} /> : null}
          <DetailsView>
            <Text variant="h3" color="white" weight="bold">
              {item.title}
            </Text>

            <Text color="white" weight="semibold">
              {format(item.start, 'EEEE, d MMM')}
            </Text>
            <MealTypePill>
              <Text color="white" weight="semibold">
                {item.mealType}
              </Text>
            </MealTypePill>
          </DetailsView>
        </BodyContainer>
      </ChatItemDialogBody>
    </>
  ) : null;
};

const BodyContainer = styled.TouchableOpacity`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 20px;
`;

const MealImage = styled.Image`
  aspect-ratio: 1;
  width: 150px;
  border-radius: 10px;
`;

const DetailsView = styled.View`
  flex: 1;
  flex-direction: column;
  gap: 10px;
  min-width: 50%;
`;

const MealTypePill = styled.View`
  padding: 0 16px;

  align-items: center;
  justify-content: center;

  height: 38px;

  border-color: white;
  border-width: 1px;
  border-radius: 20px;
  max-width: 100px;
`;
